
<ngb-rating tabindex="0" [class]="classList" (rateChange)="updateChanges($event)" [(rate)]="starRating" [attr.aria-label]="ariaLabel" 
    [attr.aria-describedby]="ariaDescribedBy" [max]="totalStars"></ngb-rating>